import React, { useState, useRef, useEffect } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const ExpandableContent = (props: any) => {
  const [expanded, setExpanded] = useState(false);
  const [showExpand, setShowExpand] = useState(false);
  const [fullHeight, setFullHeight] = useState(0);
  const contentRef = useRef<any>(null);

  useEffect(() => {
    if (contentRef.current) {
      setFullHeight(contentRef.current.scrollHeight);
      if (contentRef.current.scrollHeight > 42) {
        setShowExpand(true);
      } else {
        setShowExpand(false);
      }
    }
  }, [props.children]);

  return (
    <Box width='100%'>
      <Box
        ref={contentRef}
        sx={{
          height: expanded ? `${fullHeight}px` : '37px',
          overflow: 'hidden',
        }}
      >
        {props.children}
      </Box>
      {showExpand && (
        <Box display='flex' justifyContent='end' mt={1}>
          <IconButton onClick={() => setExpanded((prev) => !prev)}>
            {expanded ? (
              <>
                <ExpandLessIcon />
                <Typography fontSize={'12px'}>一部のみ表示</Typography>
              </>
            ) : (
              <>
                <ExpandMoreIcon />
                <Typography fontSize={'12px'}>全て表示</Typography>
              </>
            )}
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default ExpandableContent;
